import { render, staticRenderFns } from "./commonHelpCenter.vue?vue&type=template&id=031e7126"
import script from "./commonHelpCenter.vue?vue&type=script&lang=js"
export * from "./commonHelpCenter.vue?vue&type=script&lang=js"
import style0 from "./commonHelpCenter.vue?vue&type=style&index=0&id=031e7126&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports